/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { ETargetDossier } from './ETargetDossier';
import {
    ETargetDossierFromJSON,
    ETargetDossierFromJSONTyped,
    ETargetDossierToJSON,
} from './ETargetDossier';
import type { ETypeDashboardDossier } from './ETypeDashboardDossier';
import {
    ETypeDashboardDossierFromJSON,
    ETypeDashboardDossierFromJSONTyped,
    ETypeDashboardDossierToJSON,
} from './ETypeDashboardDossier';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DashboardDossierSearch
 */
export interface DashboardDossierSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardDossierSearch
     */
    concerne?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardDossierSearch
     */
    currentPri?: TextSearch;
    /**
     * 
     * @type {ETargetDossier}
     * @memberof DashboardDossierSearch
     */
    target?: ETargetDossier;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDossierSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {ETypeDashboardDossier}
     * @memberof DashboardDossierSearch
     */
    type?: ETypeDashboardDossier;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardDossierSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardDossierSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDossierSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDossierSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardDossierSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDossierSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardDossierSearch interface.
 */
export function instanceOfDashboardDossierSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardDossierSearchFromJSON(json: any): DashboardDossierSearch {
    return DashboardDossierSearchFromJSONTyped(json, false);
}

export function DashboardDossierSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDossierSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'concerne': !exists(json, 'concerne') ? undefined : TextSearchFromJSON(json['concerne']),
        'currentPri': !exists(json, 'currentPri') ? undefined : TextSearchFromJSON(json['currentPri']),
        'target': !exists(json, 'target') ? undefined : ETargetDossierFromJSON(json['target']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'type': !exists(json, 'type') ? undefined : ETypeDashboardDossierFromJSON(json['type']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardDossierSearchToJSON(value?: DashboardDossierSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'concerne': TextSearchToJSON(value.concerne),
        'currentPri': TextSearchToJSON(value.currentPri),
        'target': ETargetDossierToJSON(value.target),
        'hideMasquees': value.hideMasquees,
        'type': ETypeDashboardDossierToJSON(value.type),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

